export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-v1-480-64c3c6655846737d3b7f68f281c341d9.webp";